import { useTranslation } from "react-i18next";
import { Text } from "@/shared/ui";

/** Bold wordmark (DESIGN §4.1). No logo mark, no suffix. */
export function Brand() {
  const { t } = useTranslation();
  return (
    <Text variant="wordmark" className="leading-none">
      {t("sidebar.appName")}
    </Text>
  );
}
